<template>
  <div class="content-430">
    <div class="form-main">
      <h2 class="title">{{ Data.noticeTitle }}</h2>
      <div class="page-top">
        <span>发布学校：{{ Data.schoolName }}</span>
        <span style="margin-left: 20px">发布人：{{ Data.createName }}</span>
        <span style="margin-left: 20px">发布时间：{{ Data.sendTime }}</span>
        <span style="margin-left: 20px">年度学期：{{ yearTerm }}</span>
      </div>
      <div class="content html-reset" v-html="Data.noticeInfo"></div>
      <div class="imgList">
        <el-image
          v-for="(item, index) in PhotoIdsList"
          :key="index"
          :src="item"
          alt="img"
          class="img"
          :preview-src-list="PhotoIdsList"
        >
        </el-image>
      </div>
    </div>
    <div class="form-head">发送班级</div>
    <div class="form-main form-text">
      {{ classData }}
    </div>
    <div class="form-head">阅读统计</div>
    <div class="form-main form-inline">
      <div class="form-inline">
        共计：<span class="text"> {{ Data.noticeTotal }}</span>人 已读<span class="text skyblue">{{ Data.readNumbers }}</span>人，未读<span class="text blue">{{
          Data.noticeTotal - Data.readNumbers
        }}</span>人
      </div>
      <Button
        class="search-430"
        @click="handleDetail(Data.noticeId)"
      >查看阅读详情</Button>
    </div>
    <ReadDetailModal ref="ReadDetailModal"></ReadDetailModal>
  </div>
</template>

<script>
import eduCenter from '@/request/eduCenter/index.js';
import ReadDetailModal from '@pv/eduCenter/common/assets/components/ReadDetailModal';

export default {
  name: 'EduCenterNoticeIndexDetail',
  components: {
    ReadDetailModal
  },
  data() {
    return {
      yearTerm: '',
      imgList: [],
      selectImgList: [], // 查看图片选中的
      noticeId: '', // 通知公告id
      Data: [],
      downloadUrl: '',
      PhotoIdsList: [], // 图片预览列表
      classData: [] // 班级名称列表
    };
  },
  created() {
    this.noticeId = this.$route.query.noticeId;
    this.yearTerm = this.$route.query.yearTerm;
    this.getNoticeByNoticeId();
  },
  mounted() {
    this.getUrlToken();
  },
  methods: {
    // 上传token
    async getUrlToken() {
      const res = await this.$http.getUploadtoken();
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
      }
    },
    // 获取通知公告详情
    async getNoticeByNoticeId() {
      this.PhotoIdsList = [];
      const params = {
        noticeId: this.noticeId
      };
      const res = await eduCenter.getNoticeByNoticeId(params);
      if (res.status == 200) {
        if (res.message.photoIds) {
          res.message.photoIds.forEach((fileId) => {
            this.PhotoIdsList.push(this.downloadUrl + '?fileId=' + fileId);
          });
        }
        const classNameMap = res.message.classNameMap;
        const classArr = [];
        for (const key in classNameMap) {
          classArr.push(classNameMap[key]);
        }
        this.classData = classArr.join('、');
        this.Data = res.message;
      }
    },
    // 查看阅读详情
    handleDetail(noticeId) {
      this.$refs.ReadDetailModal.handleOpen(noticeId);
    },
    // 点击打开照片
    handleShowImgList(imglist) {
      this.selectImgList = imglist;
      this.$nextTick(() => {
        this.$refs.reviewPhoto.open();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content-430 {
  .form-head {
    background: rgba(0, 0, 0, 0.05);
    padding: 16px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    padding-left: 24px;
  }
  .form-main {
    margin-bottom: 20px;
    .title {
      font-size: 20px;
      color: #333;
      font-weight: 700;
      margin-bottom: 30px;
    }
    .page-top {
      background: #f9f9f9;
      padding: 10px;
      margin-bottom: 16px;
      padding-left: 15px;
      border: 1px solid #e4e4e4;
    }
    .content {
      line-height: 26px;
      margin-bottom: 20px;
    }
    .imgList {
      display: flex;
      align-items: center;
      margin: 10px 0;
      .img {
        width: 100px;
        height: 100px;
        margin-right: 10px;
      }
    }
  }
  .form-text {
    line-height: 24px;
  }
  .form-inline {
    display: inline-block;
    font-size: 16px;
    margin-right: 20px;
    .text {
      font-weight: 700;
    }
    .skyblue {
      color: #409eff;
    }
    .blue {
      color: #488ffa;
    }
  }
  .item {
    height: 30px;
  }
  /deep/.ivu-form-item {
    width: 30%;
  }
}
.page-right {
  text-align: right;
  margin: 10px 0;
}
.html-reset {
  /deep/ul {
    list-style-type: disc;
    list-style-position: inside;
  }
  /deep/ol {
    list-style-type: decimal;
    list-style-position: inside;
  }
}
</style>
